module.exports = __webpack_public_path__ + "media/images/costumes/top/wasou/thumbnail-4-014eacf170b95f67c5115224d75a8ff7.jpg";